<div class="p-3 forgot-password-container" data-testid="password-reset-dialog">
  <div class="w-100 d-flex justify-content-end">
    <!-- <button class="btn btn-close" onclick="onNoClick()"></button> -->
  </div>
  <h2 class="text-center mt-3" data-testid="password-reset-title">{{'login.recoveryEmail' | translate}}</h2>
  <p class="text-center opacity_text" data-testid="password-reset-description">{{'login.recoveryPassword' | translate}}</p>
  <div class="p-3">
    <form data-testid="password-reset-form">
      <div class="mb-3 d-flex flex-column align-items-start">
        <label for="email" class="form-label" data-testid="password-reset-email-label">{{'shared.email' | translate}}</label>
        <input
          id="email"
          type="email"
          class="form-control opacity_text"
          [formControl]="myControl"
          autocomplete="email"
          placeholder="ex. example@gmail.com"
          data-testid="password-reset-email-input"
          [ngClass]="{'border border-danger': myControl.get('email')?.touched && myControl.get('email')?.invalid}" />
      </div>
    </form>
    <div class="w-100 d-grid">
      <button class="btn button-color" (click)="submit()" data-testid="password-reset-submit-button">
        {{'shared.submit' | translate}}
        <i class="bi bi-arrow-right"></i>
      </button>
    </div>
  </div>
</div>
